import React from "react";
import CardDetails from "./CardDetails";

const CardItem = ({item}) => {
    return (
        <div
            className="w-full h-60 flex flex-col justify-between py-4 px-6 rounded-xl overlay-card relative"
            style={{
                backgroundImage: `url(${item.bg})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center center',
                backgroundRepeat: 'no-repeat'
            }}
        >
            <div className="mt-5 flex items-center gap-x-2 z-1">
                <h3 className="text-white mb-0 text-base font-bold">{item.title}</h3>
                {item.active ? <span className="w-14 min-w-14 h-14 rounded-3xl bg-green-500"></span> : ''}
            </div>
            <CardDetails
                item={item}
                className="flex items-center justify-between flex-wrap gap-x-1 z-1 bg-white-80 py-2 px-5 rounded-xl text-black text-s"
            />
        </div>
    )
}

export default CardItem;